<template>
  <div class="">
    <v-header :inputName='Name'></v-header>
    <div class="manpin">

      <div class="main centen container">
        <div class="main_r" style="padding-top: 0;">
          <div class="mainr_top">
            <div style="width: 120px;" class="title"><img src="../../assets/gerenzhongxin/geren16.png">
            专业选择
            </div>
            <div class="search">
              <div class="serachkuang">
                <input placeholder="请输入您想查询的专业" v-model="majorName" @keydown.enter="search" />
                <div class="sousuo" @click="search">
                  <a @click="search"><img src="../../../src/assets/img/search.png" /></a>
                </div>
              </div>
            </div>
          </div>
          <div class="tiaobaodan">
            <saixuantop1 :subject="batch.provincialBatch.indexOf('本')!=-1||batch.provincialBatch.indexOf('一段')!=-1?1:0" @select="selectType"></saixuantop1>
            <div class="two">
              <div class="schoolWZ">
                <div class="SCLeft">
                  <span>可选专业</span>
                </div>
                <div class="SCbottom">
                  <el-breadcrumb separator="">
                    <el-breadcrumb-item ><a
                        @click="selectmajor(-2)"
                        :class="allflag? 'active' :''">全选</a>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item v-for="(item,index) in list" :key="item.majorId"><a
                        @click="selectmajor(selectids.indexOf(item.majorId),item)"
                        :class=" selectids.indexOf(item.majorId)!=-1? 'active' :''">{{item.majorName}}</a>
                    </el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="已选专业"
        :show-close="false"
        :lock-scroll="false"
        :visible.sync="dialogVisible"
        width="50%">
        <div class="one">
        <div class="xinxi" v-for="(item,index) in selectlist"><span>{{item.majorName}} </span>
          <img src="../../../static/img/cha.png" @click="del(index)">
        </div>
        </div>
        <span slot="footer" class="dialog-footer">
              <el-button type="danger" style="margin-right: 50px;" @click="clear()">重 置</el-button>
              <el-button type="primary" @click="closelog">确 定</el-button>
        </span>
      </el-dialog>
      <vMassage2 :selectlist="selectlist" :flag="true" @openyixuan="openyixuan" @confirm="confirm" @clear="clear" @del="del"></vMassage2>
    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
  </div>
</template>

<script>
  import vHeader from "../../components/vHeader.vue";
  import item7 from "../../components/item7.vue";
  import vMassage2 from "../../components/vMassage2.vue";
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import jibenxinxi from '../../components/jibenxinxi.vue'
  import saixuantop1 from '../../components/saixuantop1.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      jibenxinxi,
      vMassage2,
      saixuantop1
    },
    data() {
      return {
        // 导航选中
        batch: this.$utils.getlocalStorage("userZhiYuanBatch"),
        Name: 4,
        majorName: '',
        typeId:'',
        allflag:false,
        list:[],
        selectlist:[],
        selectids:[],
        dialogVisible:false,
      }
    },
    created() {
      let map = this.$utils.getlocalStorage("zyyixuan")
      if(map){
        this.selectlist = map.list
        this.selectids = map.ids
      }
    },
    methods: {
      openyixuan(){
        if(this.selectlist.length!=0){
          this.dialogVisible = true
        } else {
          this.$alert('请选择专业', '操作提示',{lockScroll:false});
        }
      },
      search() {
        this.typeId = ''
        this.allflag =false;
        this.getMajor()
      },
      selectType(typeId) {
        this.typeId = typeId
        this.majorName = '';
        this.allflag =false;
        this.getMajor()
      },
      confirm(){
          if(this.selectids.length!=0){

            this.$utils.setlocalStorage("zyyixuan",{ids:this.selectids,list:this.selectlist});
            this.$utils.setlocalStorage("tianbaoModel",1)
            this.$router.push('/zhuan_newgaokao')
          } else {
            this.$alert('请选择专业', '操作提示',{lockScroll:false});
          }
      },
      clear(){
        this.allflag =false;
        this.selectlist =[];
        this.selectids = [];
        this.$utils.removelocalStorage("zyyixuan")
      },

      getMajor() {
        let _this = this;
        let obj = {}
        if(_this.typeId!=null&&_this.typeId!=''){
          obj.majorTypeId =  _this.typeId
        }
        if(_this.majorName!=null&&_this.majorName!=''){
          obj.majorName =  _this.majorName
        }
        this.$req.queryAllByLimit('majorTable', {
          pageNum: 1,
          pageSize: 0,
          queryObj: obj
        }).then(function(response) {
          _this.list = response.data
          _this.getAllflag()
        })
      },
      selectmajor(index,item){
        if(index == -2){
          if(!this.allflag){
            for(let a in this.list){
              if(this.selectids.indexOf(this.list[a].majorId)==-1){
                this.selectids.push(this.list[a].majorId)
                this.selectlist.push(this.list[a]);
              }
            }
            this.allflag = true
          } else {
            for(let a in this.list){
              let i = this.selectids.indexOf(this.list[a].majorId)
              if(i!=-1){
                this.selectids.splice(i,1);
                this.selectlist.splice(i,1);
              }
            }
            this.allflag = false
          }
        } else {
         if(index!=-1){
           this.selectids.splice(index,1);
           this.selectlist.splice(index,1);
         } else {
           this.selectids.push(item.majorId)
           this.selectlist.push(item);
         }
         this.getAllflag();
        }

      },
      del(index){
        this.selectids.splice(index,1);
        this.selectlist.splice(index,1);

      },
      closelog(){
        this.dialogVisible = false
        this.getMajor()
      },
      getAllflag(){
        let n = 0
        for(let a in this.list){
          if(this.selectids.indexOf(this.list[a].majorId)!=-1){n++}
        }
        if(n == this.list.length){this.allflag = true} else{
          this.allflag = false
        }
      },



      // 院校填报或专业填报
      tongyizge(bog) {
        // this.$router.push('/tiaobaozhiyuan?bog='+bog)
        this.$router.push({
          path: '/tiaobaozhiyuan',
          query: {
            bog: bog
          }
        });
      },
      // 一键填报
      yijian() {
        this.$router.push('/yijiantianbao')
      }
    },



  }
</script>

<style scoped>
  .two {
    margin-top: 10px;
    justify-content: space-around;
    width: 100%;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 50px;
  }
  .two span{
      line-height: 50px;
      margin-right: 8px;
  }
  .schoolWZ {
    width: 100%;
    height: auto;
    display: flex;
  }


  .schoolWZ .SCLeft {
    width: 115px;
  }
  .schoolWZ .SCLeft span{
    color: #000;
  }

  .schoolWZ .SCmain {
    width: 64px;
    height: 60px;
    margin-right: 15px;
    margin-top: 10px;

  }

  .schoolWZ .SCmain a {
    display: block;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
    height: 32px;
    color: #333333;
    opacity: 1;
    cursor: pointer;
    font-size: 14px;
    margin: 0 10px;
  }

  .active {
    background: #e63233;
    color: #fff !important;
    border-radius: 16px;
    padding: 6px 11px;
    box-sizing: border-box;
  }

  .schoolWZ .SCbottom {
    width: 100%;
    text-align: left;
    /* padding-bottom: 10px; */
    /* border-bottom: 1px #eee9e9 solid; */
  }

  .schoolWZ .SCbottom a {
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    padding: 6px 11px;
    line-height: 20px;
    color: #333333;
    opacity: 1;
  }



  .serachkuang .sousuo img {
    padding: 5px 15px 5px 15px;
    background: red;
    border-radius: 0 6px 6px 0;
  }

  .serachkuang input {
    border: none;
    width: 500px;
    height: 40px;
    background: #fff;
    font-size: 16px;
    line-height: 40px;
    opacity: 1;
    border: 1px solid #c0c4cc;
    border-radius: 6px 0px 0px 6px;
    padding-left: 15px;
    padding: 15px;
  }

  .serachkuang ::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .search {
    width: 500px;
    margin-left: 200px;
    height: 40px;
    margin-top: 0px;
    justify-content: center;
    align-items: center;
  }


  /* 新 */
  .miansdas {
    margin-bottom: 30px;
    width: 100%;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: url(../../assets/img/beibeiebei.png)no-repeat;
    background-size: 100% 100%;
  }

  .miansdas img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }

  .miansdas span {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .tiaobaodan {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-around;
    padding-top: 0px;
    box-sizing: border-box;
    flex-wrap: wrap;
  }

  .tiaobaodan_index1 {
    cursor: pointer;
    position: relative;
    background: url(../../assets/img/img1-56.png)no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width: 336px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .tiaobaodan_index2 {
    cursor: pointer;
    position: relative;
    background: url(../../assets/img/img2-56.png)no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width: 336px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .tiaobaodan_index3 {
    cursor: pointer;
    position: relative;
    background: url(../../assets/img/img3-56.png)no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width: 336px;
    height: 150px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .annn1 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annn2 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annn3 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #B16800;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tong {
    padding-left: 20px;
  }

  .tiaobaodan_index1 span {
    font-size: 28px;
    font-family: GEETYPE-WaonProGB-Flash H;
    font-weight: 400;
    color: #7C504F;
    line-height: 50px;
    margin-top: 10px;
  }

  .tiaobaodan_index2 span {
    font-size: 28px;
    font-family: GEETYPE-WaonProGB-Flash H;
    font-weight: 400;
    color: #566181;
    margin-top: 10px;
  }

  .tiaobaodan_index3 span {
    font-size: 28px;
    font-family: GEETYPE-WaonProGB-Flash H;
    font-weight: 400;
    color: #7A5C31;
    margin-top: 10px;
  }

  .tiaobaodan_index1 label {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #7C504F;
    line-height: 35px;
  }

  .tiaobaodan_index2 label {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #566181;
    line-height: 35px;
  }

  .tiaobaodan_index3 label {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #7A5C31;
    line-height: 35px;
  }


  /* 新 */

  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding-top: 90px;
    /* padding: 40px 0; */
    box-sizing: border-box;
    background: #EBE9E9;
  }

  .main {
    padding-bottom: 40px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    background: #EBE9E9;
  }

  .main_l {
    /* background: rgba(251, 251, 251, 1); */
    width: 290px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }


  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }


  .main_r {
    width: 1280px;
    min-height: 878px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: left;
    flex-direction: row;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top .title img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .xinxi img {
    width: 10px;
    height: 10px;
    margin-top: -3px;
    margin-left: 5px;
  }

.one {
    justify-content: left;
    align-items: flex-start;
    width: 100%;
    height: auto;
    background: #FFFFFF;
    display: flex;
    padding-left: 20px;
    flex-wrap: wrap;
  }
  .xinxi {
    padding: 0 5px 0 5px;
    width: auto;
    height: 30px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29A7E1;
    opacity: 1;
    margin-right: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
    line-height: 30px;

  }

  .xinxi span {
    text-align: center;
    font-size: 14px;
    text-decoration: none;
    color: #29A7E1;
    font-family: PingFang SC;
    font-weight: 500;

  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    margin-top: 5px;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  @media (max-width:1400px) {
    .centen {
      width: auto;
    }
  }

  @media (min-width:750px) {
    .mainr_bot2 {
      display: none;
    }
  }

  @media (max-width:750px) {
    .miansdas {
      height: 100px;
      margin-bottom: 10px;
    }

    .miansdas img {
      width: 50px;
      height: 50px;
    }

    .miansdas span {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }


    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .manpin {}

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      margin-left: 0;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/tianbaoList/selectzhuanye.vue